import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-stock-count-refresh',
  templateUrl: './stock-count-refresh.component.html',
  styleUrls: ['./stock-count-refresh.component.css']
})
export class StockCountRefreshComponent implements OnInit {
    stockCountKeyno;

    public edit?: Edit;

    public refreshing = false;

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.stockCountKeyno = this.stateService.getStateParams()['stockcount_keyno'];
    }

    private async loadEdit() {
        if (!!this.stockCountKeyno) {
            this.edit = (await this.datatask.Post(982, { stockcount_keyno: this.stockCountKeyno }))[0];
        }
    }

    public async refreshChanges() {
        if (!!this.edit) {
            try {
                this.refreshing = true;

                await this.datatask.Post(981, { stockcount_keyno: this.edit.stockcount_keyno });

                this.stateService.back();
            } finally {
                this.refreshing = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    infotext: string;
    stockcount_keyno: string;
    stockplace_name: string;
    approved: string;
    stockcount_date: string;
}
